//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['partyObj'],
  data () {
    return {
      partyid: this.$route.params.artid,
      rulecontent: []
    }
  },
  mounted () {
    if (this.partyObj.explist.length > 0) {
      this.rulecontent = this.partyObj.explist
    }
  },
  methods: {}
}
